import { getGeoCountry } from "asos-site-chrome-store-presentation";

import euCountries from "@src/helpers/euCountries";
import { publishGeoCountry } from "@template/state/modules/layout";

export const dispatchCookiesPolicy = store => {
  const geoCountry = getGeoCountry();
  const withCookiePolicy =
    geoCountry && euCountries.includes(geoCountry.toUpperCase());

  if (!withCookiePolicy) return;

  store.dispatch(publishGeoCountry(geoCountry));
};
